/* eslint-disable @typescript-eslint/naming-convention */
import { ITeamWizardsStatusColors } from "../../../../../types/teamWizards";

export const teamWizardsStatusColors: ITeamWizardsStatusColors = {
    TEAM_ASSIGNMENT_MODE: {
        memberIcon: "#bfccff"
    },
    JOIN_PROJECT_MODE: {
        memberIcon: "#bfccff"
    },
    JOIN_PROJECT_GROUP_STATUSES_MODE: {
        memberIcon: {
            default: "#e65aff",
            failed: "#ff406e"
        },
        status: {
            Pending: "#bebebe",
            InProgress: "#e65aff",
            Complete: "#e65aff",
            Failed: "#ff406e"
        }      
    },
    TEAM_MEMBER_DISPLAY_ITEMS_GROUP_STATUSES_MODE: {
        memberIcon: {
            default: "#00ff9d",
            failed: "#ff406e"
        },
        status: {
            Pending: "#bebebe",
            InProgress: "#00ff9d",
            Complete: "#00ff9d",
            Failed: "#ff406e"
        }
    },
    TEAM_MEMBER_WITH_CONTEXT_MENU_MODE: {
        memberIcon: "#00ff9d"
    },
    LEAVE_PROJECT_MODE: {
        memberIcon: "#bfccff"
    },
    LEAVE_PROJECT_GROUP_STATUSES_MODE: {
        memberIcon: {
            default: "#e65aff",
            failed: "#ff406e"
        },
        status: {
            Pending: "#bebebe",
            InProgress: "#e65aff",
            Complete: "#e65aff",
            Failed: "#ff406e"
        }
    },
    OFFBOARD_TEAM_MEMBER_MODE: {
        memberIcon: "#bfccff"
    },
    OFFBOARD_TEAM_MEMBER_GROUP_STATUSES_MODE: {
        memberIcon: {
            default: "#e65aff",
            failed: "#ff406e"
        },
        status: {
            Pending: "#bebebe",
            InProgress: "#e65aff",
            Complete: "#e65aff",
            Failed: "#ff406e"
        }
    }
} as const;
